import { Middleware } from "@reduxjs/toolkit";
import { enumerateDevices } from "../../actions";
import {
  DEVICES_SELECTOR_BY_DEVICE_TYPE,
  DEVICE_TYPES,
  SET_ACTIVE_DEVICE_ACTION_BY_DEVICE_TYPE,
  STORAGE_KEY_BY_DEVICE_TYPE,
} from "../../../constants";
import { getDefaultDevice, includesSerialized } from "../utils";

export const SYNCHRONIZATION_FROM_STORAGE_TRIGGER =
  enumerateDevices.fulfilled.toString();

export const synchronizeSelectedDevicesFromStorageMiddleware: Middleware =
  (store) => (next) => (action) => {
    next(action);

    if (action.type !== SYNCHRONIZATION_FROM_STORAGE_TRIGGER) {
      return;
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const deviceType of DEVICE_TYPES) {
      const storageKey = STORAGE_KEY_BY_DEVICE_TYPE[deviceType];
      const selector = DEVICES_SELECTOR_BY_DEVICE_TYPE[deviceType];
      const availableDevices = selector(store.getState());
      const setActiveDevice =
        SET_ACTIVE_DEVICE_ACTION_BY_DEVICE_TYPE[deviceType];
      const storedDeviceRaw = localStorage.getItem(storageKey);
      const storedDevice =
        storedDeviceRaw !== null ? JSON.parse(storedDeviceRaw) : null;

      if (storedDevice !== null) {
        const isStoredDeviceAmongAvailableDevices = includesSerialized(
          availableDevices,
          storedDevice,
        );

        if (isStoredDeviceAmongAvailableDevices && storedDevice) {
          store.dispatch(setActiveDevice(storedDevice));

          // eslint-disable-next-line no-continue
          continue;
        }
      }

      const defaultDevice = getDefaultDevice(availableDevices);

      if (defaultDevice !== undefined) {
        store.dispatch(setActiveDevice(defaultDevice));

        // eslint-disable-next-line no-continue
        continue;
      }

      if (availableDevices.length !== 0) {
        const [firstAvailableDevice] = availableDevices;

        store.dispatch(setActiveDevice(firstAvailableDevice));

        // eslint-disable-next-line no-continue
        continue;
      }

      localStorage.removeItem(storageKey);
    }
  };
